import * as React from 'react'

const SvgCaretUpIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.625 12.5L10 7.5l4.375 5h-8.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgCaretUpIcon
